import React from 'react'
import classnames from 'classnames'
import styles from "./icon.module.scss"

interface IProps extends React.Props<any> {
  icon: string,
  spin?: boolean
  size?: number,
  className?: string,
  fontSize?: string,
  onClick?: (e: React.MouseEvent) => any,
  style?: React.CSSProperties
}

function Icon ({ icon, size = 16, className, fontSize, onClick, style, spin }: IProps) {
  const font = fontSize ? fontSize : `${size}px`
  const classes = classnames('icon', className, {
    [styles['icon-spin']]: spin
  })

  return (
    <svg
      style={style}
      onClick={onClick}
      fontSize={font}
      className={classes} 
      aria-hidden="true">
      <use xlinkHref={`#${icon}`}></use>
    </svg>
  )
}

export default React.memo(Icon)
